import 'mdn-polyfills/NodeList.prototype.forEach';
import 'classlist-polyfill';
import '../../../polyfills/Iterators';
import '../../../polyfills/DOMTokenList';

import Utilities                                  from '../../utilities';
import defaultSettings                            from './BinderSettings';
import { FallcoClass }                            from '../../../classes/FallcoClass';
import { BinderManager, _mergeData as mergeData } from './BinderManager';
import {
  _parseDataBind,
  _stringifyDataBind,
  _appendDataBindAttr,
  _makeObservable
}                                                 from './BinderMethods';
import ko                                         from 'knockout';

/**
 * @class
 * @extends FallcoClass
 */
class ControlsBinding extends FallcoClass {
  constructor() {
    super('controls_binding');
    
    this.settings = defaultSettings;
    
    this.instances = {};
    
    this._promiseListeners = [];
    
    if (window.fallco.controls_binding) {
      return window.fallco.controls_binding;
    }
    
    this.utilities = {
      mergeData,
      makeObservable:     _makeObservable,
      parseDataBind:      _parseDataBind,
      stringifyDataBind:  _stringifyDataBind,
      appendDataBindAttr: _appendDataBindAttr
    };
    
    this.ko = ko;
    
    window.addEventListener('DOMContentLoaded', () => this.activateBinding());
    
    return super.expose_to_public('controls_binding', this);
  }
  
  /**
   * @see activateBinding
   *
   * @param {jQuery|HTMLElement} target?
   * @return {BinderManager|*}
   *
   * @deprecated
   */
  // eslint-disable-next-line camelcase
  update_binding(target) {
    return this.activateBinding(target);
  }
  
  /**
   * Inizializza la libreria ed associa ai vari controls tutti gli eventi necessari.
   *
   * Se non viene passato alcun parametro come "target", inizializza i controls di tutta la pagina che abbiano
   * l'attributo "fw-control-bind-to", altrimenti inizializza solo i controls con lo stesso attributo presenti all'interno
   * del target specificato.
   *
   * @param {jQuery|HTMLElement} target?
   * @param {boolean} overwrite?
   * @param {Object} customViewModel?
   * @return {BinderManager|*}
   */
  activateBinding(target, overwrite, viewModel, makeObservale) {
    target = Utilities.get_js_target(target);
    
    const targetId = target.name || target.id || target.localName || target.nodeName;
    
    let existingViewModel = viewModel;
    
    if (this.instances[targetId]) {
      if (!overwrite) {
        return console.error(`Esiste già un istanza per il target specificato (${targetId})`);
      } else {
        existingViewModel = this.instances[targetId].observablesList;
        
        this.instances[targetId].destroyInstance();
      }
    }
    
    this.instances[targetId] = new BinderManager(target, existingViewModel, makeObservale, this.ko);
    
    this._checkIsModal(target, this.instances[targetId]);
    
    for (const entry of this._promiseListeners) {
      if (entry.name === targetId) {
        entry.promiseResolve(this.instances[targetId]);
      }
    }
    
    return this.instances[targetId];
  }
  
  /**
   *
   * @param instanceName
   * @param waitForIt
   * @returns {Promise<BinderManager>|BinderManager}
   */
  getInstance(instanceName, waitForIt = false) {
    const targetId = !instanceName ? '#document' : instanceName;
    
    if (waitForIt) {
      if (this.instances[targetId]) {
        return Promise.resolve(this.instances[targetId]);
      } else {
        return new Promise(resolve => {
          this._promiseListeners.push({
            name:           targetId,
            promiseResolve: resolve
          });
        });
      }
    }
    
    return this.instances[targetId];
  }
  
  /**
   *
   * @param target
   * @return {boolean|void}
   */
  removeBinding(target) {
    let targetId;
    
    if (typeof target === 'string') {
      targetId = target;
    } else {
      target   = Utilities.get_js_target(target);
      targetId = target.name || target.id || target.localName || target.nodeName;
    }
    
    if (!this.instances[targetId]) {
      return console.error(`Sembra che l'istanza per il target specificato (${targetId}) non sia presente.`);
    }
    
    this.instances[targetId].destroyInstance(true);
    
    delete this.instances[targetId];
    
    return true;
  }
  
  /**
   *
   * @param {HTMLElement} target
   * @param {BinderManager} instance
   * @private
   */
  _checkIsModal(target, instance) {
    target = (target instanceof Document) ? target.body : target;
    
    if (typeof $.fn.get_closest_modal_popup_obj !== 'function') {
      return;
    }
    
    const modalInstance = $(target).get_closest_modal_popup_obj();
    
    if (modalInstance && !modalInstance.onHiddenAdded) {
      modalInstance.$modal.on('hidden.bs.modal', () => this._onModalClose(target));
      
      // Aggiungo un controllo per capire se il listener sull'evento hidden è già stato aggiunto, in modo tale da assicurarsi
      // che anche in caso di "reload_content", l'evento non venga aggiunto più volte, il che creerebbe un errore in fase di
      // chiusura del modale, in quanto cercherebbe di eliminare l'istanza del binding più volte.
      modalInstance.onHiddenAdded = true;
    }
  }
  
  /**
   *
   * @param target
   * @private
   */
  _onModalClose(target) {
    this.removeBinding(target);
  }
}

export default new ControlsBinding();
